import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { MyBooksRequest } from '../../requests/platform/my-books.request';
import { MyBooksResponse } from '../../responses/platform/my-books.response';
import { GetMyShoppingResponse } from '../../responses/platform/get-my-shopping-response';
import { ReturnStruct } from '../../structs/return.struct';
import { RatingPostRequest } from '../../requests/platform/rating-post.request';
import { GetMyShoppingKitPaymentResponse } from '../../responses/platform/get-my-shopping-kit-payment.response';

@Injectable({
  providedIn: 'root'
})
export class MyShoppingService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public get(): Observable<GetMyShoppingResponse> {
    return this.http.get<GetMyShoppingResponse>(environment.urlApiPlatform + 'MyShopping', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public post(ratingPostRequest: RatingPostRequest): Observable<ReturnStruct> {
    return this.http.post<ReturnStruct>(environment.urlApiPlatform + 'MyShopping', ratingPostRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getById(idKitPaymentItem: number): Observable<GetMyShoppingKitPaymentResponse> {
    return this.http.get<GetMyShoppingKitPaymentResponse>(environment.urlApiPlatform + 'MyShopping/idKitPaymentItem/' + idKitPaymentItem, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}